import classNames from 'classnames';

import type { ComparisonTableProps } from 'components/ComparisonTable/types';

import useStyles from './styles';

const ComparisonTable = ({ features }: ComparisonTableProps) => {
  const styles = useStyles();

  return (
    <div className={styles.rootFallback}>
      <i className={classNames(styles.titleFallback, 'skeleton')} />
      <table className={styles.table}>
        <thead>
          <tr className={styles.row}>
            <th className={styles.col}>
              <i className={classNames(styles.full, 'skeleton')} />
            </th>
            <th className={styles.col}>
              <i className={classNames(styles.full, 'skeleton')} />
            </th>
            <th className={styles.col}>
              <i className={classNames(styles.full, 'skeleton')} />
            </th>
          </tr>
          {features.map(item => (
            <tr key={item.label} className={styles.row}>
              <td className={classNames(styles.col, styles.featureCol, styles.featureColFallback)}>
                <i className={classNames(styles.full, 'skeleton')} />
              </td>
              <td className={styles.col}>
                <i className={classNames(styles.full, 'skeleton')} />
              </td>
              <td className={styles.col}>
                <i className={classNames(styles.full, 'skeleton')} />
              </td>
            </tr>
          ))}
        </thead>
      </table>
      <i className={classNames(styles.tableActionFallback, 'skeleton')} />
    </div>
  );
};

export default ComparisonTable;
